import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from '../../atoms'

type DatePickerMobileFooterProps = {
  onClick: () => void
  disabled: boolean
}

export const DatePickerMobileFooter: React.FC<DatePickerMobileFooterProps> = ({
  onClick,
  disabled,
}) => {
  return (
    <div className='flex justify-end border-t border-t-border bg-background px-[5vw] py-[10px]'>
      <Button onClick={onClick} className='px-5 py-[10px]' disabled={disabled}>
        <FormattedMessage
          id='ui.BudgetPicker.save'
          defaultMessage='Enregistrer'
        />
      </Button>
    </div>
  )
}
